// 📄 pages/Proyectos/components/ChecklistIncidentBanner.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Incidente } from '../../../services/incidenteService.ts';

interface ChecklistIncidentBannerProps {
  projectId: string;
  incidente: Incidente;
  compact?: boolean;
}

export default function ChecklistIncidentBanner({ projectId, incidente, compact = false }: ChecklistIncidentBannerProps) {
  return (
    <div className={`bg-red-500/10 border border-red-500/30 text-red-400 rounded-xl flex items-center justify-between gap-3 animate-fadeIn ${compact ? 'p-2.5 text-xs' : 'p-4 text-sm mb-4'}`}>
      <div className="flex items-center gap-2.5 min-w-0">
        <AlertTriangle className={`flex-shrink-0 ${compact ? 'w-4 h-4' : 'w-5 h-5'}`} />
        <span className="truncate">
          ⚠️ Hay un incidente sin resolver relacionado a este paso en {incidente.ambiente} — revisa antes de continuar en PRD.
        </span>
      </div>
      <Link
        to={`/proyecto/${projectId}/incidentes?incidenteId=${incidente.id}`}
        className="underline whitespace-nowrap font-medium hover:text-red-300 flex-shrink-0"
      >
        Ver incidente
      </Link>
    </div>
  );
}
